import React, { useState } from 'react';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Web3Provider, useWeb3 } from './context/Web3Context';
import { ToastProvider } from './context/ToastContext';
import SplashScreen from './components/Loading/SplashScreen';
import Header from './components/Layout/Header';
import BottomNav from './components/Layout/BottomNav';
import ParticleCanvas from './components/UI/ParticleCanvas';
import LandingPage from './components/Landing/LandingPage';
import RegisterPage from './components/Register/RegisterPage';
import HomePage from './components/Dashboard/HomePage';
import InvestPage from './components/Invest/InvestPage';
import TeamPage from './components/Team/TeamPage';
import IncomePage from './components/Income/IncomePage';
import RFCoinPage from './components/RFCoin/RFCoinPage';
import './styles/app.css';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/invest" element={<InvestPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/income" element={<IncomePage />} />
        <Route path="/rfcoin" element={<RFCoinPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </AnimatePresence>
  );
}

function AppRoutes() {
  const { account, isRegistered, isConnecting } = useWeb3();
  if (!account) return <LandingPage />;
  if (isConnecting) return <div className="dash-loader"><div className="loader-text">Connecting...</div></div>;
  if (!isRegistered) return <RegisterPage />;
  return (<>
    <Header />
    <div style={{ flex: 1 }}><AnimatedRoutes /></div>
    <BottomNav />
  </>);
}

export default function App() {
  const [splash, setSplash] = useState(true);
  return (
    <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ToastProvider>
        <Web3Provider>
          <ParticleCanvas />
          {splash && <SplashScreen onComplete={() => setSplash(false)} />}
          <AppRoutes />
        </Web3Provider>
      </ToastProvider>
    </HashRouter>
  );
}
